import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Batteries} from '../pages/layout/list-batteries/list-batteries.component';
import {Scootersearnings} from '../pages/e-commerce/charts-panel/charts-panel.component'
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { of as observableOf, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssetsdashboardService {

  constructor(private afs: AngularFirestore) { }

  getScootersUnoccupied(){
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.AssetsDashboardCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data();
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  } 

  getKmsCOData(){
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.AssetsDashboardCollection).doc('LYiHTBjrrG7XQTBYJHdn').snapshotChanges().pipe(map(action => {
      const data = action.payload.data();
      const id = action.payload.id;
      return { id, ...data };
  }));
  }
}

